<template>
  <div :class="$attrs.class">
    <div class="dash-section">
      <div class="header">
        <h2 class="title">Average Platform Rating</h2>
      </div>
      <span v-if="feedbackMetrics.loading" class="value">
        <skeleton width="75px" height="35px" />
      </span>
      <span v-else-if="feedbackMetrics.metrics.feedbackCount === 0" class="empty">No Results</span>
      <span v-else class="value">
        {{ Number(feedbackMetrics.metrics.averageAppRating).toFixed(2) }}
      </span>
    </div>
    <div class="dash-section">
      <div class="header">
        <h2 class="title">Average Counselor Rating</h2>
      </div>
      <span v-if="feedbackMetrics.loading" class="value">
        <skeleton width="75px" height="35px" />
      </span>
      <span v-else-if="feedbackMetrics.metrics.feedbackCount === 0" class="empty">No Results</span>
      <span v-else class="value">
        {{ Number(feedbackMetrics.metrics.averageCounselorRating).toFixed(2) }}
      </span>
    </div>
  </div>
</template>

<script>
import Skeleton from '../../../Skeleton.vue'

export default {
  name:'FeedbackMetrics',
  components: {
    Skeleton,
  },
  inject:['feedbackMetrics'],
}
</script>

<style lang="scss" scoped>
.dash-section {

  min-height: 0px;
  margin-bottom: 2rem;

  .header {
    margin-bottom: 0;
    text-align: center;
    flex-direction: column;
  }

  .value {
    font-weight: 700;
    font-size: 3rem;
    padding: 0 2.45rem 1.5rem 2.45rem;
    text-align: center;
  }
}

.dash-sub-section {
  border-top: none;
}

</style>
